import React from 'react'
import { withRouter } from 'withRouter'
import { routeMapping } from 'routes'
import ProcessPage from 'components/ProcessPage'
import SsoPage from 'containers/Auth/SSO/SsoPage'
import ConfirmationElement, { ICON } from 'containers/Auth/ConfirmationElement'
import { VuiButton } from '@topkamera/viso-ui'

const WorkspaceSsoNoAccess = ({
  router, email
}) => {

  const redirectToLogin = () => {
    sessionStorage.setItem('accessToken', '')
    router.navigate(routeMapping.LOGIN.path)
  }

  return (
    <ProcessPage splitPage={true} customClass='split-page-full-height-popup'>
      {() => (
        <div>
          <SsoPage
            title='No workspace access'
            description={`You don't have access to a workspace.`}
          >
            <div className='sso-page-form vui-pt-20'>
              <div className='sso-page-form__field sso-page-form__field--margin-md vui-flex vui-justify-center'>
                <div className='sso-page-form__button'>
                  <div className='vui-mb-28 vui-pb-2'>
                    <ConfirmationElement icon={ICON['LOCKED']} color='label' />
                  </div>
                  <VuiButton
                    onClick={redirectToLogin}
                    color='accent0'
                    style='filled'
                    radius='pill'
                    label='Switch account'
                    isBlock
                  />
                </div>
              </div>
              <div className='sso-page-form__helper sso-page-form__helper--body sso-page-form__helper--360'>
                Your account {email} hasn't been granted access to a workspace. Please contact your administrator to request access.
              </div>
            </div>
          </SsoPage>
        </div>
      )}
    </ProcessPage>
  )
}

export default withRouter(WorkspaceSsoNoAccess)